import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ['label', 'available', 'hoursRange']

  connect() {
    this.sync()
  }

  toggle() {
    this.sync()
  }

  sync() {
    const available = this.availableTarget.checked

    this.labelTarget.textContent = available ? 'Open' : 'Closed'

    // Below md fields stack — d-none (no reserved height).
    // md+ fields are inline — invisible keeps label+input height so the row does not jump.
    this.hoursRangeTarget.classList.toggle('d-none', !available)
    this.hoursRangeTarget.classList.toggle('d-md-flex', !available)
    this.hoursRangeTarget.classList.toggle('invisible', !available)
  }
}
